module.exports = __webpack_public_path__ + "img/PT502.7fccf194.png";